<div class="schedule">
  <table>
    <thead>
      <tr>
        <th>
          <div class="div-th">
            <mat-icon class="icon">calendar_month</mat-icon>
            {{ "date.day" | translate }}
          </div>
        </th>

        <th>
          <div class="div-th">
            <mat-icon class="icon">toggle_on</mat-icon>
            {{ "units.status" | translate }}
          </div>
        </th>

        <th>
          <div class="div-th">
            <mat-icon class="icon">schedule</mat-icon>
            {{ "units.timeRange" | translate }}
          </div>
        </th>

        <th>
          <div class="div-th">
            <mat-icon class="icon">edit</mat-icon>
            {{ "datatable.actions" | translate }}
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let day of days" [attr.data-value]="day.value">
        <td class="day">
          {{ day.name }}
        </td>

        <td class="status">
          <mat-slide-toggle [checked]="_schedule[day.value].enable" (change)="setSchedule($event, day.value, 'toggle')">
            {{ (_schedule[day.value].enable ? "status.active" : "status.inactive") | translate }}
          </mat-slide-toggle>
        </td>

        <td class="timeRange default-time">
          <div class="column">
            <div class="schedule-item" *ngFor="let timeRange of _schedule[day.value].times; let i = index">
              <div class="arrow">
                <input matInput aria-label="start time" [format]="24" [ngxTimepicker]="pickerStart"
                  [value]="_schedule[day.value].times[i][0]" readonly class="time-picker" />
                <ngx-material-timepicker #pickerStart [theme]="theme"
                  (timeSet)="setSchedule($event, day.value, 'startTime', i)">
                </ngx-material-timepicker>

                <mat-icon>arrow_right_alt</mat-icon>

                <input matInput aria-label="end time" [format]="24" [ngxTimepicker]="pickerEnd"
                  [value]="_schedule[day.value].times[i][1]" readonly class="time-picker" />
                <ngx-material-timepicker #pickerEnd [theme]="theme"
                  (timeSet)="setSchedule($event, day.value, 'endTime', i)">
                </ngx-material-timepicker>
              </div>
            </div>
          </div>
        </td>

        <td>
          <ng-container *ngIf="_schedule[day.value].times.length < 3">
            <mat-icon class="iconAction add" (click)="addRange(day.value)">add_alarm</mat-icon>
          </ng-container>

          <ng-container *ngIf="_schedule[day.value].times.length > 1">
            <mat-icon class="iconAction delete" (click)="deleteRange(day.value)">alarm_off</mat-icon>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>